import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { AppBar, Box, CardContent, Toolbar } from "@mui/material";
import ReactPaginate from "react-paginate";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import NoRecordMessage from "../../common/components/NoRecordMessage";
import TableSkeleton from "../../common/components/TableSkeleton";
import GroupCard from "../components/GroupCard";
import SearchBox from "../../common/components/SearchBox";
import { useTheme } from "@mui/material/styles";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

import NewGroupDialog from "../components/NewGroupDialog";
import { getVotingGroups, publishVoting } from "../../../store/voting/actions";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";

const Groups = (props) => {
  const { getVotingGroups, publishVoting, user, votingGroups } = props;
  const { hasPermissions } = useRequiredAuth();
  useEffect(() => {
    document.title = `IPPIS - Groups(${votingGroups.length}) | Voting`;
  });
  const [loading, setLoading] = useState(false);
  const [searchTeam, setSearchTeam] = useState("");
  const theme = useTheme();
  const [showGroupDialog, setShowGroupDialog] = useState(false);
  const [filteredRequests, setFilteredRequests] = useState([...votingGroups]);
  const [confirmToPublishVoting, setConfirmToPublishVoting] = useState(false);
  const [publishing, setPublishing] = useState(false);
  useEffect(() => {
    getVotingGroups(setLoading);
  }, []);

  useEffect(() => {
    const filtered = [...votingGroups].filter(({ name }) =>
      (name || "").toLowerCase().includes(searchTeam.toLowerCase())
    );

    setFilteredRequests(filtered);
    paginate(filtered);
  }, [searchTeam, votingGroups]);

  const [paginatedItems, setPaginatedItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 10;

  const paginate = (items) => {
    const endOffset = itemOffset + itemsPerPage;
    setPaginatedItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  };
  useEffect(() => {
    paginate(filteredRequests);
  }, [itemOffset, itemsPerPage, filteredRequests]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % filteredRequests.length || 0;

    setItemOffset(newOffset);
  };
  const onSearch = (term) => {
    setSearchTeam(term);
  };

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <div className="w-100">
        <AppBar
          position="static"
          elevation={0}
          style={{ overflow: "hidden" }}
          className="app-bar w-100"
        >
          <Toolbar className="row justify-content-between">
            <div className="col-lg-8">
              <Typography
                variant="h6"
                noWrap
                component="div"
                // sx={{ display: { xs: "none", sm: "block" } }}
              >
                <span>VOTING</span>
                <span className="mr-1 ml-1" style={{ color: "#2a7790" }}>
                  <span
                    className="material-icons  text-dark"
                    style={{ position: "relative", top: "4px" }}
                  >
                    chevron_right
                  </span>
                </span>

                <span style={{ color: "rgb(7, 142, 206)" }}>
                  <span style={{ color: "rgb(7, 142, 206)" }}>Groups</span>
                </span>
              </Typography>
            </div>
            {showGroupDialog && (
              <NewGroupDialog
                showGroupDialog={showGroupDialog}
                setShowGroupDialog={setShowGroupDialog}
              />
            )}
            <div className="col-lg-4 d-flex justify-content-between">
              <div style={{ maxWidth: "100vw" }}>
                <SearchBox
                  disabled={!votingGroups.length}
                  onSearch={onSearch}
                  placeholder="Search…"
                />
              </div>
              <div>
                {hasPermissions(["IS_HR"]) && (
                  <div className="d-flex justify-content-between">
                    <Button
                      sx={{ borderRadius: 2 }}
                      className="px-2"
                      variant="contained"
                      color="primary"
                      onClick={() => setShowGroupDialog(true)}
                      size="sm"
                    >
                      <span className="material-icons">add</span>Group
                    </Button>
                    <Button
                      sx={{ borderRadius: 2 }}
                      color="success"
                      variant="contained"
                      className="px-2 ml-2"
                      onClick={() => setConfirmToPublishVoting(true)}
                      size="sm"
                    >
                      <span className="material-icons">publish</span>Publish
                      Voting
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </Toolbar>
        </AppBar>
        {confirmToPublishVoting && (
          <ConfirmationDialog
            confirmationDialog={confirmToPublishVoting}
            message={`Are you sure you want to publish voting on department level?`}
            setConfirmationDialog={() => setConfirmToPublishVoting(false)}
            isLoading={publishing}
            disabled={publishing}
            onYes={() =>
              publishVoting("D", (status, res) => {
                setConfirmToPublishVoting(status);
                setPublishing(status);
                if (!status && !!res) {
                  getVotingGroups(setLoading);
                }
              })
            }
          />
        )}
        <div
          style={{
            padding: theme.spacing(0.4),
            height: "auto",
            maxHeight: "auto",
            margin: "1.2em",
            backgroundColor: "#fff",
            borderRadius: "0.5rem",
            overflow: "visible",
            boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
            MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
          }}
        >
          <CardContent
            style={{
              padding: ".1em",
              height: "auto",
              minHeight: "auto",
              overflow: "auto",
            }}
          >
            <table className="table-striped table-hover table-sm  fixTableHead">
              <thead>
                <tr style={{ backgroundColor: "#f0f2f5" }}>
                  <th scope="col" className="text-left">
                    No
                  </th>
                  <th scope="col" className="text-left">
                    Group Name
                  </th>
                  <th scope="col" className="text-left">
                    FiscalYear
                  </th>

                  <th scope="col" className="text-center">
                    TotalUnits
                  </th>
                  <th scope="col" className="text-center">
                    Voting Participation
                  </th>
                  <th scope="col" className="text-right">
                    OpeningDate
                  </th>
                  <th scope="col" className="text-right">
                    ClosingDate
                  </th>
                  <th scope="col" className="text-right">
                    CreatedOn
                  </th>

                  <th scope="col" className="text-center">
                    Status
                  </th>

                  <th scope="col" className="text-right">
                    <span className="mr-3">Actions</span>
                  </th>
                </tr>
              </thead>

              {loading ? (
                <TableSkeleton cols={9} />
              ) : (
                <tbody>
                  {paginatedItems.map((request, index) => (
                    <GroupCard
                      user={user}
                      request={request}
                      index={index + 1}
                      key={request.id}
                    />
                  ))}
                </tbody>
              )}
            </table>

            {!!paginatedItems.length && votingGroups.length >= itemsPerPage && (
              <div
                className="justify-content-center mt-2"
                style={{ overflow: "hidden" }}
              >
                <ReactPaginate
                  breakLabel="..."
                  nextLabel={
                    <>
                      <span className="pr-1 d-none d-md-inline">Next</span>
                      <i className="fas fa-angle-double-right"></i>
                    </>
                  }
                  previousLabel={
                    <>
                      <i className="fas fa-angle-double-left"></i>
                      <span className="pl-1  d-none d-md-inline">Previous</span>
                    </>
                  }
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={1}
                  onPageChange={handlePageClick}
                  pageCount={pageCount}
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1 mt-1"
                  previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1 mt-1"
                  nextLinkClassName="btn btn-outline-info btn-sm ml-1 mt-1"
                  activeLinkClassName="active"
                />
              </div>
            )}

            <NoRecordMessage
              isEmpty={!filteredRequests.length && !loading}
              title="No Results found"
            />
          </CardContent>
        </div>
      </div>
    </Box>
  );
};

const mapStateToProps = ({ user, votingGroups }) => {
  return { user, votingGroups };
};
const mapDispatchToProps = {
  getVotingGroups,
  publishVoting,
};

export default connect(mapStateToProps, mapDispatchToProps)(Groups);
